import { ApolloProvider } from '@apollo/client';
import React, { FC, ReactElement } from 'react';
import { render as reactTestingRender, RenderOptions } from '@testing-library/react';
import { I18nProvider } from '@lingui/react';
import { ThemeProvider } from 'styled-components';
import { createTheme, GlobalStyles as GDSGlobalStyles } from '@bechtel/gds';
import { client } from '~/apollo-client';
import { ConfigProvider } from '~/hooks/use-config';
import { AppUserProvider } from '~/components/molecules/appuser/appuser-context';
import { i18n } from '@lingui/core';
import { MemoryRouter } from 'react-router';
import { messages } from '~/locales/en/messages';
import { en } from 'make-plural/plurals';

const theme = createTheme();
// TODO: fix client global styles import error
i18n.loadLocaleData('en', { plurals: en });
i18n.load('en', messages);
i18n.activate('en');

const AllTheProviders: FC<any> = ({ children }) => {
  return (
    <ApolloProvider client={client}>
      <I18nProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <ConfigProvider>
            <AppUserProvider>
              <MemoryRouter>
                <GDSGlobalStyles />
                {children}
              </MemoryRouter>
            </AppUserProvider>
          </ConfigProvider>
        </ThemeProvider>
      </I18nProvider>
    </ApolloProvider>
  );
};

const AllTheProvidersWORouter: FC<any> = ({ children }) => {
  return (
    <ApolloProvider client={client}>
      <I18nProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <ConfigProvider>
            <AppUserProvider>
              <GDSGlobalStyles />
              {children}
            </AppUserProvider>
          </ConfigProvider>
        </ThemeProvider>
      </I18nProvider>
    </ApolloProvider>
  );
};

const customRender: any = (
  ui: ReactElement<any>,
  isNotRouteProvider?: boolean,
  options?: Omit<RenderOptions, 'wrapper'>
) => reactTestingRender(ui, { wrapper: !isNotRouteProvider ? AllTheProviders : AllTheProvidersWORouter, ...options });

export * from '@testing-library/react';
export { customRender as render };
